import { render, staticRenderFns } from "./SelectionsPrintGroups.vue?vue&type=template&id=8c4eb7e6&scoped=true&"
import script from "./SelectionsPrintGroups.vue?vue&type=script&lang=js&"
export * from "./SelectionsPrintGroups.vue?vue&type=script&lang=js&"
import style0 from "./SelectionsPrintGroups.vue?vue&type=style&index=0&id=8c4eb7e6&prod&lang=css&"
import style1 from "./SelectionsPrintGroups.vue?vue&type=style&index=1&id=8c4eb7e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4eb7e6",
  null
  
)

export default component.exports